<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header :header-title="$t('SURVEY_MGMT.SURVEY.SEND_MODEL')" />

      <div>
        <div class="main-form">
          <div>
            <span class="span-label">
              <form @submit.prevent="saveModel">
                <div v-if="model.logo" class="image-preview">
                  <img :src="model.logo" alt="Uploaded Image" class="uploaded-image" />
                </div>

                <div class="upload-container">
                  <file-upload class="change-media"
                    accept="image/png,image/gif,image/jpeg"
                    @input-file="onDirectFileUpload($event)">
                    <woot-button class="change-button">{{ $t('SURVEY_MGMT.MODELS.FORM.UPLOAD_PICTURE') }}</woot-button>
                  </file-upload>
                </div>

                <woot-input class="input-text" v-model.trim="model.name"
                  :error="$v.model.name.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :label="$t('SURVEY_MGMT.MODELS.FORM.NAME')" type="text"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.NAME')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.DESCRIPTION') }}</label>
                <textarea class="input-text" v-model.trim="model.description"
                  :error="$v.model.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.DESCRIPTION')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.GREETINGS') }}</label>
                <textarea class="input-text" v-model.trim="model.message"
                  :error="$v.model.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.GREETINGS')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.THANK') }}</label>
                <textarea class="input-text" v-model.trim="model.thank_message"
                  :error="$v.model.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.THANK')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.REDIRECT') }}</label>

                <div class="redirect-container">
                  <textarea class="input-text" v-model.trim="model.redirect_url"
                    :error="$v.model.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.REDIRECT')" />
                  <div class='switch-container'>
                    <woot-switch size="medium" class="auto-offline--switch" v-model.trim="model.redirect" />
                  </div>
                </div>
                  
                <div v-for="(question, index) in model.questions" :key="index" class="question-container">
                  <woot-input
                    class="input-text question-input"
                    v-model.trim="question.question"
                    :label="`${index + 1}º Pergunta`"
                    type="text"
                    placeholder="Digite a pergunta"
                  />
                  <div class="question-options">
                    <select v-model="question.type" class="question-dropdown" @change="handleQuestionTypeChange(question.type)">
                      <option v-for="type in types" :key="type.type" :value="type.type">
                        {{ $t(`SURVEY_MGMT.MODELS.FORM.TYPES.${type.show}`) }}
                      </option>
                    </select>
                    <label class="question-checkbox">
                      {{$t('SURVEY_MGMT.MODELS.FORM.REQUIRED')}}
                      <input type="checkbox" v-model="question.required" />
                    </label>
                    <woot-button
                      class="nomargin-button"
                      v-tooltip.top="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_VALUE')"
                      variant="smooth"
                      color-scheme="alert"
                      size="small"
                      icon="dismiss-circle"
                      class-names="grey-btn"
                      @click="removeQuestion(index)"
                    />
                  </div>
                </div>
                <div v-if="showRatingAMessages" class="rating-a-messages">
                  <label>{{ $t('SURVEY_MGMT.MODELS.FORM.GOOD_MESSAGE') }}</label>
                  <textarea class="input-text" v-model.trim="model.good_message"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.GOOD_MESSAGE')" />
                  <label>{{ $t('SURVEY_MGMT.MODELS.FORM.NEUTRAL_MESSAGE') }}</label>
                  <textarea class="input-text" v-model.trim="model.neutral_message"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.NEUTRAL_MESSAGE')" />
                  <label>{{ $t('SURVEY_MGMT.MODELS.FORM.BAD_MESSAGE') }}</label>
                  <textarea class="input-text" v-model.trim="model.bad_message"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.BAD_MESSAGE')" />
                </div>
                <woot-button type="button" @click="addQuestion">
                  {{ $t('SURVEY_MGMT.MODELS.FORM.ADD_QUESTION') }}
                </woot-button>
                <woot-button>
                  {{ $t('SURVEY_MGMT.SURVEY.SEND') }}
                </woot-button>
              </form>
            </span>
            <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import { DirectUpload } from 'activestorage';
import {
  buildAccountDirectUploadUrl,
  buildBlobUrl,
} from 'dashboard/helper/directUploadHelper';
import alertMixin from 'shared/mixins/alertMixin';
import { minLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import FileUpload from 'vue-upload-component';
import { INPUT_TYPE } from '../constants';
import getUuid from '../../../../../widget/helpers/completeUuid';

export default {
  mixins: [alertMixin],
  components: {
    FileUpload,
  },
  props: {
    editModel: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      show: true,
      showDeleteTablePopup: false,
      types: INPUT_TYPE,
      showRatingAMessages: false,
      model: this.editModel ? { ...this.editModel } : {
        name: '',
        description: '',
        logoUrl: '',
        questions: [],
        message: '',
        redirect_url: '',
        redirect: false,
        thank_message: '',
        good_message: '',
        neutral_message: '',
        bad_message: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      uiFlags: 'getUIFlags',
      currentUser: 'getCurrentUser',
      indexTab: 'attributes/getIndexTabAttributes',
    }),
    deleteRejectText() {
      return this.$t('SURVEY_MGMT.NO');
    },
    isEdit() {
      return !!this.editModel;
    },
  },
  validations: {
    model: {
      name: {
        required,
        minLength: minLength(1),
      },
      description: {
        required,
      },
    },
  },
  methods: {
    closeDeleteGroup() {
      this.showDeleteTablePopup = false;
      this.selectedAttribute = {};
    },
    async deleteTable(id) {
      try {
        await this.$store.dispatch('customSurveys/deleteModel', {
          id: id,
        });
        this.showAlert(this.$t('SURVEY_MGMT.SURVEY.DELETE.SUCCESS_MESSAGE'));
      } catch (error) {
        const errorMessage =
          error?.response?.message ||
          this.$t('SURVEY_MGMT.SURVEY.DELETE.ERROR_MESSAGE');
          console.log(error)
        this.showAlert(errorMessage);
      }
    },
    confirmTableDeletion() {
      this.deleteTable(this.model.id);
      this.closeDeleteGroup();
    },
    openDeleteTable() {
      this.showDeleteTablePopup = true;
    },
    async onDirectFileUpload(file) {
      if (!file) {
        return;
      }
      const uploadUrl = buildAccountDirectUploadUrl(this.accountId);
      const upload = new DirectUpload(file.file, uploadUrl, {
        directUploadWillCreateBlobWithXHR: xhr => {
          xhr.setRequestHeader('api_access_token', this.currentUser.access_token);
        },
      });
      upload.create(async (error, blob) => {
        if (error) {
          this.showAlert(error);
        } else {
          const fileUrl = buildBlobUrl(blob.signed_id, blob.filename);
          this.model.logo = fileUrl;
        }
      });
    },
    onClose() {
      this.$emit('on-close');
    },
    async saveModel() {
      this.uuidValue = getUuid();
      try {
        await this.$store.dispatch('customSurveys/createSurvey', {
          smart_surveys: {
            name: this.model.name,
            description: this.model.description,
            questions: this.model.questions,
            logo: this.model.logo,
            uuid: this.uuidValue,
            model_uuid:  this.model.uuid,
            message: this.model.message,
            redirect_url: this.model.redirect_url,
            redirect: this.model.redirect,
            thank_message: this.model.thank_message,
            good_message: this.model.good_message,
            neutral_message: this.model.neutral_message,
            bad_message: this.model.bad_message,
            active: true,
            until_date: null
          }
        });
        this.onClose();
      } catch (error) {
        console.error('Erro ao processar', error);
        throw error;
      }
    },
    addQuestion() {
      if (!this.model.questions) {
        this.model.questions = [];
      }
      this.model.questions.push({
        question: '',
        type: 'text',
        required: false,
      });
    },
    removeQuestion(index) {
      this.model.questions.splice(index, 1);
    },
    handleQuestionTypeChange(type) {
      if (type === 'rating_a' && !this.showRatingAMessages) {
        this.showRatingAMessages = true;
      }
    },
  },
  mounted() {
    if (this.model.questions.some(question => question.type === 'rating_a')) {
      this.showRatingAMessages = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.redirect-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.upload-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch-container {
  display: flex;
  width: 100%;
  padding: 8px;
  height: 100%;
  margin-bottom: 16px;
  max-width: 70px;
}

.uploaded-image {
  max-width: 300px;
  max-height: 100px;
}

.image-preview {
  display: flex;
  justify-content: center;
}

.change-button {
  margin-top: 8px;
}

.question-options {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.rating-a-messages {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid var(--color-border);
  border-radius: 5px;
  background-color: var(--color-surface-2);
}
</style>